import { Required, DataValidator, IsArray, IsString } from "@/utils/type-vaildator";
import api from "./api";

export interface GenerateSora2TextToVodRequest {
  agentId: string;
  text: string;
  type: number;
  model: string;
  duration?: number;
  aspectRatio?: string;
  level?: string;
  imageSize?: string;
}

class MakeGenerateResponseRaw {
  @Required("taskIds cannot be empty")
  @IsString("taskIds must be a string")
  taskIds: string;
}

// 生成 Sora2 视频(文生视频)
export const generateSora2TextToVod = async ({
  agentId,
  text,
  type,
  model,
  duration,
  aspectRatio,
  level,
  imageSize,
}: GenerateSora2TextToVodRequest): Promise<string> => {
  const res = await api.post<MakeGenerateResponseRaw>("/sj/sora2/txt2vod/create", {
    agent_id: agentId,
    text,
    level,
    model,
    duration,
    aspectRatio: aspectRatio,
    type,
    imageSize,
    resolution: imageSize,
  });
  const root = res.data;
  const validated = DataValidator.validateOrThrow(root, MakeGenerateResponseRaw);
  return validated.taskIds;
};
